import { listen, qs, qsa, toggle } from '@fluorescent/dom';

export default function OptionButtons(els) {
  const groups = els.map(createOptionGroup);

  function destroy() {
    groups && groups.forEach(group => group());
  }

  return { groups, destroy };
}

function createOptionGroup(el) {
  const select = qs('select', el);
  const buttons = qsa('[data-button]', el);

  const buttonClick = listen(buttons, 'click', e => {
    e.preventDefault();
    const { button } = e.currentTarget.dataset;

    buttons.forEach(btn =>
      toggle(btn, 'selected', btn.dataset.button === button)
    );

    const opt = qs(`[data-value-handle="${button}"]`, select);
    opt.selected = true;

    // const chip = e.target;
    // const selectedLabel = qs('.product-form__selected-label', el);

    // selectedLabel.innerText = chip.dataset.button;

    select.dispatchEvent(new Event('change'));
  });

  return () => buttonClick();
}
